<template>
    <div>
    <!-- Menu Buttons -->
    <router-link class="nav-link" :to="{ name: 'Register' }">Register</router-link>
    <router-link class="nav-link" :to="{ name: 'Login' }">Login</router-link>
    <router-link class="nav-link" :to="{ name: 'MultiAccessLogin' }">Teacher Access</router-link>
    </div>
</template>

<script>
  export default {
    name: 'GuestMenuCard2',
    data: () => ({
        //
    }),
  }
</script>

<style scoped>
.nav-link{
    margin-right: 15px;
    color: #44546E;
    text-decoration: none;
    font-weight: 600;
    opacity: 0.85;
    transition: color 0.2s ease, opacity 0.2s ease;
}
.nav-link:hover{
    color: #FB8C00;
    opacity: 1;
}
</style>